import { render, staticRenderFns } from "./PensionCalculatorTab.vue?vue&type=template&id=03ccd28a&scoped=true"
import script from "./PensionCalculatorTab.vue?vue&type=script&lang=js"
export * from "./PensionCalculatorTab.vue?vue&type=script&lang=js"
import style0 from "./PensionCalculatorTab.vue?vue&type=style&index=0&id=03ccd28a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03ccd28a",
  null
  
)

export default component.exports